<template>
  <div>
    Almacén - Via de envio
    <br />
    <a
      class="btn blue waves-effect waves-light modal-trigger"
      href="#shipvia-modal-selector"
      ><i class="mdi mdi-factory mdi-24px"></i>{{ almacen_name }}</a
    >

    <!-- Modal Structure -->
    <div id="shipvia-modal-selector" class="modal">
      <div class="modal-content">
        <h4>Selecciona el almacen</h4>
        <form class="row">
          <div class="input-field col s12">
            <select
              v-model="almacen_shipvia"
              @change="saveAlmacenShipvia"
              class="browser-default"
              required
              name="almacen"
              id="almacen"
            >
              <option value="" selected>
                Selecciona el almacen
              </option>
              <option
                v-for="(almacen_shipvia, key) in almacenes_shipvias"
                :key="key"
                :value="almacen_shipvia"
              >
                {{ almacen_shipvia.almacen.iclocdesc }}
              </option>
            </select>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <a href="#!" class="modal-close waves-effect waves-green btn-flat"
          >Cerrar</a
        >
      </div>
    </div>
  </div>
</template>
<script>
import M from "materialize-css";
import almacenes_shipvias from "../../../recursos/almacenes_shipvias.json";

export default {
  data() {
    let almacen = undefined,
      shipvia = undefined,
      almacen_shipvia_local_storage = window.localStorage.getItem(
        "almacen-shipvia"
      );
    if (almacen_shipvia_local_storage) {
      almacen_shipvia_local_storage = JSON.parse(almacen_shipvia_local_storage);
      almacen = almacen_shipvia_local_storage.almacen;
      
      let _shipvia = almacenes_shipvias[`${almacen.iclocdesc}\t${almacen.iclocid}`];
      
      if (_shipvia){
        shipvia = _shipvia.shipvia;
        almacen_shipvia_local_storage.shipvia = shipvia;
        window.localStorage.setItem("almacen-shipvia", JSON.stringify(almacen_shipvia_local_storage));
      }
      else shipvia = almacen_shipvia_local_storage.shipvia;
      console.log("almacen-shipvia", almacen_shipvia_local_storage);

    }
    let almacenes = JSON.parse(window.localStorage.getItem("almacenes")),
      shipvias = JSON.parse(window.localStorage.getItem("shipvias"));

    //Relacion de almacenes shipvias
    /** almacenes_shipvias = Helpers.relacionarAlmacenesShipvias(
        almacenes,
        shipvias
      );**/

    return {
      almacen_shipvia: almacen_shipvia_local_storage,
      almacenes: almacenes,
      shipvias: shipvias,
      almacen: almacen,
      shipvia: shipvia,
      almacenes_shipvias: almacenes_shipvias,
      modal_shipvia: undefined,
    };
  },
  created() {
    setTimeout(() => {
      console.log("almacen-shipvia", this.almacen_shipvia);
      this.modal_shipvia = M.Modal.init(
        document.querySelector("#shipvia-modal-selector"),
        { outDuration: 100 }
      );
      if (!this.almacen_shipvia) this.modal_shipvia.open();
    }, 500);
    if (this.almacen_shipvia)
      this.$emit("almacen-shipvia", this.almacen_shipvia);
    
  },
  computed: {
    almacen_name() {
      let almacen = this.almacen;
      if (almacen) return almacen.iclocdesc;
      return "SIN ALMACEN SELECCIONADO";
    },
  },
  methods: {
    saveAlmacenShipvia() {
      this.modal_shipvia.close();
      this.almacen = this.almacen_shipvia.almacen;
      this.shipvia = this.almacen_shipvia.shipvia;

      window.localStorage.setItem(
        "almacen-shipvia",
        JSON.stringify(this.almacen_shipvia)
      );
      this.$emit("almacen-shipvia", this.almacen_shipvia);
      this.$forceUpdate();
      setTimeout(()=>{
        // Refresh
        location.reload();
      }, 1000);
    },
  },
};
</script>